import './styles/main.scss';
import AuthSplitter from '@pages';
import { withProviders } from './providers';
import store from "../app/store";
import { userCheckAuthTC } from '@entities/user/model/user.actions';

import version from './version';

class Application {
  constructor() {
    if (import.meta.env.VITE_MODE === 'local') {
      window.appVersion = version.combine();
    }
  }

  async init() {
    await store.dispatch(userCheckAuthTC());
    return withProviders(AuthSplitter);
  }
}

export default await (new Application()).init();
